import { render, staticRenderFns } from "./FRData.vue?vue&type=template&id=0e39988e&scoped=true"
import script from "./FRData.vue?vue&type=script&lang=js"
export * from "./FRData.vue?vue&type=script&lang=js"
import style0 from "./FRData.vue?vue&type=style&index=0&id=0e39988e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e39988e",
  null
  
)

export default component.exports